/* this file is transformed by vux-loader */
/* eslint-disable */
// 首页功能导航映射
export var menuMapping = {
  10001: 'AcceptDealWith',
  10002: 'AcceptDealWith',
  10003: 'AcceptDealWith',
  10004: 'AcceptDealWith',
  10005: 'AcceptDealWith',
  10006: 'AcceptDealWith',
  10007: 'AcceptDealWith',
  10008: 'AcceptDealWith',
  10009: 'AcceptDealWith',
  20001: 'VisitOrder',
  20002: 'AbnormalOrder',
  20003: 'OverdueOrder',
  20004: 'SendMe',
  20005: '',
  20006: '',
  20007: 'DOC',
  20008: 'FAQ',
  20009: '',
  20010: 'SparepartStock',
  20011: 'SparepartExamine',
  20012: '',
  20013: '',
  20014: '',
  20015: '',
  20016: 'MySparepart',
  20017: 'StockLog',
  20018: 'SparepartLog',
  20019: '',
  20020: '',
  20021: ''
};
export var orderList = {
  10001: 0,
  // 待我处理
  10002: 1,
  // 待我派单
  10003: 2,
  // 待我接单
  10004: '',
  // 待我预约
  10005: 3,
  // 待我服务
  10006: '',
  // 待我协同
  10007: 5,
  // 待我完成
  10008: '',
  // 待我回执
  10009: '',
  // 待我收款
  20001: 10,
  // 回访工单
  20002: '',
  // 异常工单
  20003: '',
  // 逾期工单
  20004: '' // 抄送给我
};

// [
//   { 'code': 20001, 'name': '回访工单' },
//   { 'code': 20002, 'name': '异常工单' },
//   { 'code': 20003, 'name': '逾期工单' },
//   { 'code': 20004, 'name': '抄送给我' },
//   { 'code': 20005, 'name': '客户管理' },
//   { 'code': 20006, 'name': '产品管理' },
//   { 'code': 20007, 'name': '企业文档' },
//   { 'code': 20008, 'name': 'FAQ' },
//   { 'code': 20009, 'name': '备件商品' },
//   { 'code': 20010, 'name': '备件库存' },
//   { 'code': 20011, 'name': '备件审批' },
//   { 'code': 20012, 'name': '备件入库' },
//   { 'code': 20013, 'name': '备件出库' },
//   { 'code': 20014, 'name': '备件调拨' },
//   { 'code': 20015, 'name': '备件分配' },
//   { 'code': 20017, 'name': '库存日志' },
//   { 'code': 20018, 'name': '备件日志' },
//   { 'code': 20019, 'name': '佣金结算' },
//   { 'code': 20020, 'name': '财务对账' },
//   { 'code': 20021, 'name': '回访计划' }
// ]